import classNames from 'classnames';
import Flex from 'components/common/Flex';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const WeRaiseTopNav = () => {
  const links = [
    { title: 'Dashboard', link: '/' },
    { title: 'Donor management', link: 'donors' },
    { title: 'Sponsorships', link: 'beneficiaries' },
    { title: 'Gift Aid', link: '#', disable: true },
    { title: 'Reports', link: '#', disable: true },
    { title: 'Projects', link: 'project' }
  ];

  const { pathname } = useLocation();

  const path = () => {
    if (pathname !== '/') {
      const getPath = pathname.split('/');
      return getPath[1];
    } else return pathname;
  };

  return (
    <Card className="mb-3 wr-raise-top-nav d-none d-lg-block">
      <Card.Body className="py-0">
        <Flex>
          {links?.map(item => (
            <Link
              key={item.title}
              to={item.link}
              className={classNames('me-4', {
                active: path() === item.link,
                disable: item.disable
              })}
            >
              {item.title}
            </Link>
          ))}
        </Flex>
      </Card.Body>
    </Card>
  );
};

export default WeRaiseTopNav;
